import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export default function ProjectModal({ project, onClose }) {
  return (
    <AnimatePresence>
      {project && (
        <motion.div
          data-testid="project-modal-overlay"
          className="fixed inset-0 z-[90] flex items-center justify-center bg-black/80 backdrop-blur-sm px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            data-testid="project-modal-panel"
            className="relative w-full max-w-2xl border border-[#01FFFF]/30 bg-[#0A0A12] max-h-[85vh] overflow-y-auto p-6 md:p-10"
            initial={{ opacity: 0, y: 30, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.97 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              data-testid="project-modal-close-button"
              onClick={onClose}
              aria-label="Close project detail"
              className="absolute top-4 right-4 flex h-9 w-9 items-center justify-center border border-[#01FFFF]/40 bg-black/50 hover:bg-[#01FFFF]/10"
            >
              <X size={16} className="text-[#01FFFF]" />
            </button>

            <span className="font-heading text-6xl text-[#01FFFF]/10 leading-none">
              {project.index}
            </span>

            <span className="mt-2 block font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF007F]">
              {project.tag}
            </span>
            <h3 className="mt-3 font-heading text-2xl md:text-3xl uppercase text-[#E0E6ED]">
              {project.title}
            </h3>
            <p className="mt-4 font-mono text-sm leading-relaxed text-[#8A9AAB]">
              {project.longDescription}
            </p>

            <div className="mt-6 flex flex-wrap gap-2" data-testid="project-modal-stack">
              {project.stack.map((s) => (
                <span
                  key={s}
                  className="border border-[#01FFFF]/25 px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-[#01FFFF]"
                >
                  {s}
                </span>
              ))}
            </div>

            <div className="mt-6 flex items-center gap-6 font-mono text-xs text-[#8A9AAB]">
              <span>ROLE: <span className="text-[#E0E6ED]">{project.role}</span></span>
              <span>CTX: <span className="text-[#E0E6ED]">{project.context}</span></span>
            </div>

            {project.link && (
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="project-modal-link-button"
                className="mt-6 inline-flex items-center gap-2 border border-[#FF007F] px-4 py-2.5 font-mono text-xs uppercase tracking-widest text-[#FF007F] hover:bg-[#FF007F] hover:text-black"
              >
                View Project ↗
              </a>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
